import styled from 'styled-components';
import { useWidgetTokenStore } from '@elfsight/lib-utils';
import { Form, useFormReset } from '@elfsight/widget-form-builder/widget';
import {
  createReadableClass,
  useRefWrappedCallback
} from '@elfsight/widget-utils';
import type { FormPageProps } from '../../../common';
import { defaultGetDisplayedFields } from '../utils';
import { FormLayout } from './form-layout';

export function FormPage({
  formLayoutProps,
  formSettings,
  hidden = false
}: FormPageProps & { hidden?: boolean }) {
  const { fields, onSubmitSuccessful, recaptcha } = formSettings;
  const { getDisplayedFields = defaultGetDisplayedFields } = formLayoutProps;

  const widgetTokenStore = useWidgetTokenStore();
  const widgetToken = widgetTokenStore.get();
  const reset = useFormReset(getDisplayedFields(fields));

  const onSubmitSuccessfulWithFormReset = useRefWrappedCallback(
    (...args: Parameters<NonNullable<typeof onSubmitSuccessful>>) => {
      onSubmitSuccessful?.(...args);
      reset();
    }
  );

  return (
    <PageContainer $hidden={hidden}>
      <Form
        {...formSettings}
        widgetToken={widgetToken}
        onSubmitSuccessful={onSubmitSuccessfulWithFormReset}
      >
        <FormLayout
          {...formLayoutProps}
          fields={fields}
          withRecaptcha={recaptcha}
        />
      </Form>
    </PageContainer>
  );
}

const PageContainer = styled.div.attrs({
  className: createReadableClass({ component: 'checkout-form-page' })
})<{ $hidden: boolean }>`
  display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
  flex-direction: row;
  gap: 10px;

  width: 100%;
`;
